import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import Menu from "src/pages/common/Menu";
import Wikibank from "src/assets/icons/logo-icon.png";
import Icon4 from "src/assets/icons/layers.svg";
import IconPocket from "src/assets/icons/pocket.svg";
import { useEffect } from "react";
import withSession from "src/utils/withSession";
import UserIcon from "src/assets/icons/user.svg";
import DatabaseIcon from "src/assets/icons/database.svg";
import * as SC from "./style"
import { multipleQueries } from "src/utils/graph/GraphExplorer";
import { Columns, Hash, Inbox, LogOut } from "react-feather";
import { Storage } from "src/utils/storage";
import { translate } from "src/utils/translate";

export const accessTypes = {
  pretrained: ["pretrained", "Pretrained", "pre-trained", "Pre-trained"],
  projects: ["project", "Project", "projects", "Projects"],
  presets: ["preset", "Preset", "presets", "Presets"],
  datasets: ["dataset", "Dataset", "datasets", "Datasets"],
  trains: ["train", "trains", "Train", "Trains"],
  analytics: ["analytic", "Analytic", "analytics", "Analytics"],
  dashboard: ["dashboard", "Dashboard", "dashboards", "Dashboards"]
}

const Menubar: React.FC<any> = ({ data }): JSX.Element => {
  const { companyId, language, bankId }: any = useParams()
  const [menuStatus, setMenuStatus] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const { push, location } = useHistory();
  const [menuLeftItem, setmenuLeftItem] = React.useState([]);
  const [admin, setadmin] = React.useState(false)
  const [menuRightItems, setmenuRightItem] = React.useState([]);

  useEffect(() => {
    (async () => {
      await fetchData();
      await loadData();
    })();
  }, []);


  const fetchData = async () => {
    const me = Storage.get('meCurrent')
    const accountId: string = me.account.id
    const meCurrent: any = Storage.get('meCurrent')

    const result: any = await multipleQueries([
      {
        type: 'findOne',
        target: "User",
        alias: "user",
        id: meCurrent?.user?.id,
        output: {
          id: true,
          admin: true,
        },
      },
      {
        type: 'findOne',
        target: "Company",
        alias: "company",
        id: companyId,
        output: {
          id: true,
          name: true,
          // logoURL: true,
          // color: true,
        },
      },
      {
        type: 'findOne',
        target: 'Account',
        alias: 'account',
        where: { id: accountId },
        output: {
          id: true,
          createdAt: true,
          status: true,
          planType: true,
          customActivate: true,
        }
      }
    ]);

    if (result.user.admin === true) {
      setadmin(true)
    }

    const menuLeftItems: any = [];

    menuLeftItems.push({
      titleName: <><span>{translate(language, "Banques")}</span></>,
      titleLogo: <Columns size={20} />,
      path: `/${language}/companies/${companyId}/banks`,
      icon: true,
      links: [
        `/${language}/companies/${companyId}/banks`,
        `/${language}/companies/${companyId}/banks/${bankId}`,
        `/${language}/companies/${companyId}/documents`,
      ],
    })

    menuLeftItems.push({
      titleName: <><span>{translate(language, "Ecritures comptables")}</span></>,
      titleLogo: Icon4,
      path: `/${language}/companies/${companyId}/dash?tab=request`,
      links: [
        `/${language}/companies/${companyId}/dash`,
        '/:language/companies/:companyId/dash/analytics/:requestID/document',
        '/:language/companies/:companyId/dash/analytics/:requestID/information',
        '/:language/companies/:companyId/dash/analytics/:requestID/developers',
        '/:language/companies/:companyId/dash/analytics/:requestID/comments',
        '/:language/companies/:companyId/dash/analytics/:requestID/validation',
        '/:language/companies/:companyId/dash/analytics/:requestID/data',
        '/:language/companies/:companyId/dash/analytics/:requestID',
        '/:language/companies/:companyId/dash/analytics/:requestID/overview',
      ],
    })

    if (
      (window.location.pathname === `/${language}`)) {
      setmenuLeftItem([]);
      setmenuRightItem([
        {
          titleName: <><span>Inbox</span></>,
          titleLogo: <Inbox size={20} />,
          path: `/${language}/inbox`,
          icon: true,
          links: [
            `/${language}/inbox`,
          ]
        }
      ] as any);
    } else {
      menuLeftItems.push({
        titleName: <><span>Inbox</span></>,
        titleLogo: <Inbox size={20} />,
        path: `/${language}/inbox`,
        icon: true,
        links: [
          `/${language}/inbox`,
        ]
      })
      setmenuLeftItem(menuLeftItems);
      if ((result.company && result.company)) {
        const menuRightItem: any = [
          {
            titleName: result.company.name,
            title: <div className="dfac">{showLogo(result.company.color, result.company.logoURL)}</div>,
            dropdown: true,
            isCompany: true,
            path: `/${language}`,
          }
        ];
        setmenuRightItem(menuRightItem);
      } else {
        setmenuRightItem([]);
      }
    }
    setLoading(false);
  };

  const loadData = async () => {
    setLoading(false);
  };

  const showLogo = (color: string, logoURL: string) => {
    if (logoURL?.length) {
      return (<div className="img_wrap"><img src={logoURL} alt={logoURL} /></div>)
    } else {
      return (<span className="colorBlock" style={{ background: color }} />)
    }
  };
  return (
    <>
      <SC.StyledMenubar>
        <div className={`nav-wrapper ${menuStatus && "active"}`}>

          <div className="logo">
            <a onClick={() => {
              push(`/fr`)
            }}>
              <img src={Wikibank} />
            </a>
          </div>
          <div className="header-main">
            <div className="headerSectionMenu">
              <div className="headerWrapMenu">
                <div className="headerMenu">
                  {
                    companyId && <div className="left-block">
                    {loading === false &&
                      menuLeftItem.map((item: any, i: number) => {
                        let isMenu = null;
                        let ActiveColor = false;
                        if (item.links) {
                          for (const link of item.links) {
                            isMenu = true;
                            if (location.pathname === link) {
                              ActiveColor = true;
                              break;
                            }
                          }
                        }
                        return (
                          <Menu
                            key={i}
                            title={item.title}
                            icon={item?.icon}
                            titleName={item.titleName}
                            titleLogo={item.titleLogo}
                            changeTab={() => { push(item.path); setMenuStatus(false); }}
                            ActiveColor={ActiveColor}
                            activeItem={location.pathname.includes(item.path) || isMenu}
                          />
                        );
                      })}
                  </div>
                  }
                  <div className="right-block">
                    {loading === false &&
                      menuRightItems.map((item: any, i: number) => {
                        return (
                          <Menu
                            key={i}
                            title={item.title}
                            icon={item?.icon}

                            titleName={item.titleName}
                            titleLogo={item.titleLogo}
                            changeTab={() => { push(item.path); setMenuStatus(false); }}
                            ActiveColor={false}
                            isCompany={item.isCompany}
                            activeItem={location.pathname.includes(item.path) || true}
                            dropdown={item.dropdown}
                            dropdownList={item.dropdownList}
                          />
                        )
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="icons_wrap">
              {admin === true ? <>
                <Menu
                  titleName={'Correspondances'}
                  titleIcon={<Hash size={20} style={{ verticalAlign: "middle" }} />}
                  changeTab={() => {
                    push(`/${language}/correspondances`)
                  }}
                  activeItem={
                    `/${language}/correspondances`.includes("?")
                      ? `/${language}/correspondances`.split("?")[0] === location.pathname
                      : location.pathname.includes(`/${language}/correspondance`)
                  }
                />
                <Menu
                  titleName={'Comptes'}
                  titleLogo={IconPocket}
                  changeTab={() => {
                    push(`/${language}/comptes`)
                  }}
                  activeItem={
                    `/${language}/comptes`.includes("?")
                      ? `/${language}/comptes`.split("?")[0] === location.pathname
                      : location.pathname.includes(`/${language}/compte`)
                  }
                />
                <Menu
                  titleName={'Cabinets'}
                  titleLogo={Icon4}
                  changeTab={() => {
                    push(`/${language}/cabinets`)
                  }}
                  activeItem={
                    `/${language}/cabinets`.includes("?")
                      ? `/${language}/cabinets`.split("?")[0] === location.pathname
                      : location.pathname.includes(`/${language}/cabinet`)
                  }
                />

                <Menu
                  titleName={'Codes APEs'}
                  titleLogo={DatabaseIcon}
                  changeTab={() => {
                    push(`/${language}/plan-comptable`)
                  }}
                  activeItem={
                    `/${language}/plan-complable`.includes("?")
                      ? `/${language}/plan-complable`.split("?")[0] === location.pathname
                      : location.pathname.includes(`/${language}/plan-complable`)
                  }
                />
                <Menu
                  titleName={'User'}
                  titleLogo={UserIcon}
                  changeTab={() => {
                    push(`/${language}/account`)
                  }}
                  activeItem={
                    `/${language}/account`.includes("?")
                      ? `/${language}/account`.split("?")[0] === location.pathname
                      : location.pathname.includes(`/${language}/account`)
                  }
                />
              </>: <></>}
              <Menu
                titleName={'Log Out'}
                titleIcon={<LogOut size={20} style={{ verticalAlign: "middle" }} />}
                changeTab={() => push(`/${language}/logout`)}
                activeItem={
                  "/logout".includes("?")
                    ? "/logout".split("?")[0] === location.pathname
                    : location.pathname.includes("/logout")
                }
              />
            </div>
          </div>
        </div>
      </SC.StyledMenubar>
    </>
  );
};
export default withSession(Menubar);



// WEBPACK FOOTER //
// ./src/pages/common/Menubar/index.tsx